export type KursDauerEinheit = 'Tag(e)' | 'Woche(n)' | 'Monat(e)';

export const KURS_DAUER_EINHEIT_OPTIONS: KursDauerEinheit[] = ['Tag(e)', 'Woche(n)', 'Monat(e)'];

export interface RueckzahlungsMonatEntry {
    monat: number;
    verbleibendeSumme: number;
}

export interface FortbildungsBerechnung {
    bindungsmonate: number;
    monatlicheMinderung: number;
    staffel: RueckzahlungsMonatEntry[];
}

export const getMaxBindungsmonate = (kursDauerMonate: number): number => {
    if (kursDauerMonate <= 1) return 6;
    if (kursDauerMonate <= 2) return 12;
    if (kursDauerMonate <= 4) return 24;
    return 36;
};

export const convertKursDauerToMonate = (anzahl: number, einheit: KursDauerEinheit): number => {
    if (!Number.isFinite(anzahl) || anzahl <= 0) return 0;
    if (einheit === 'Monat(e)') return anzahl;
    if (einheit === 'Woche(n)') return anzahl / 4;
    return anzahl / 30;
};

export const formatKursDauerText = (anzahl: string, einheit: KursDauerEinheit): string => {
    const num = Number(anzahl);
    if (!anzahl.trim() || !Number.isFinite(num) || num <= 0) return '____________';
    return `${num} ${einheit}`;
};

export const calculateFortbildungsRueckzahlung = (
    seminarkostenEur: number,
    kursDauerMonate: number
): FortbildungsBerechnung | null => {
    if (!Number.isFinite(seminarkostenEur) || seminarkostenEur <= 0) return null;
    if (!Number.isFinite(kursDauerMonate) || kursDauerMonate <= 0) return null;

    const bindungsmonate = getMaxBindungsmonate(kursDauerMonate);
    const monatlicheMinderung = seminarkostenEur / bindungsmonate;
    const staffel: RueckzahlungsMonatEntry[] = [];

    for (let monat = 0; monat <= bindungsmonate; monat += 1) {
        const verbleibendeSumme = Math.max(0, seminarkostenEur - monat * monatlicheMinderung);
        staffel.push({ monat, verbleibendeSumme });
    }

    return { bindungsmonate, monatlicheMinderung, staffel };
};

export const formatEuro = (value: number): string => {
    if (!Number.isFinite(value)) return '____________';
    const rounded = Math.round(value * 100) / 100;
    return rounded.toFixed(2).replace('.', ',');
};
